<app-breadcrumbs title="{{ id ? 'DELIVERY_ZONES.EDIT_TITLE' : 'DELIVERY_ZONES.CREATE_TITLE' }}" [first]="'MENU.ADMINISTRATION.DELIVERY_ZONES'" [url]="'/delivery-zones'" [id]="breadcrumbsId"></app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="((authorities.create && id == null) || (authorities.update && id != null))" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="save" [disabled]="!pendingChanges" [text]="'SHARED.SAVE_CHANGES' | translate" type="success" (onClick)="saveChanges($event)"></dx-button>
</div>

<div class="row">
    <div class="col-12 col-xxl-4">
        <dx-form #form class="form-vertical" [formData]="formData" [showColonAfterLabel]="false" (onFieldDataChanged)="fieldDataChanged($event)">
            <dxi-item dataField="name" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 50, readOnly: !((authorities.create && id == null) || (authorities.update && id != null)) }">
                <dxo-label location="left" alignment="left" [text]="'SHARED.NAME' | translate"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="municipalities">
                <dxo-label location="top" alignment="left" [text]="'MENU.DATA_MANAGEMENT.MUNICIPALITIES' | translate"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                <app-tag-box 
                    [url]="municipalitiesUrl"
                    [selectedData]="formData?.municipalities" 
                    [dataSource]="municipalities" 
                    [valueExpr]="'id'" 
                    [displayExpr]="'name'" 
                    [readOnly]="false" 
                    (onSelectionChangedEvent)="onMunicipalitiesChanged($event)"
                >
                </app-tag-box>
            </dxi-item>
        </dx-form>
    </div>
    <div class="col-12 col-xxl-8">

    </div>
</div>